import {ChakraProvider} from '@chakra-ui/react';
import {lightTheme} from '@mediwareinc/wellsky-dls-react';
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';

export const ThemeProvider = ({children}) => (
  <ChakraProvider theme={lightTheme}>{children}</ChakraProvider>
);
